export default "__VITE_ASSET__C_bSJXp___"